import { InviteLandingScreen } from "@/features/invite";

export default InviteLandingScreen;
